import React, { useCallback, useEffect, useRef, useState } from 'react';
import CardLayout from '../common/CardLayout';
import CondensacaoData from './CondensacaoData';
import TableCondensador from './TableCondensador';

import {
	Accordion,
	AccordionContent,
	AccordionItem,
	AccordionTrigger,
} from '../../components/ui/accordion';
import temperaturaParaPressao from '../../calc/temperaturaParaPressao';
import { delayTime } from '../../constants';
import apiUltimaLeituraCondensacao from '../../services/apis/Leituras/apiUltimaLeituraCondensacao';
import apiTbu from '../../services/apis/apiTbu';

const  Condensacao = ({ 
	Condensacao, 
	bombas, 
	ventiladores, 
	setCapacidadesRegimes, 
	capacidadesRegimes,
	setPressaoReferenciaRegime,
}) => {
	
	
	const [tbu, setTbu] = useState();
	const [temperatura, setTemperatura] = useState();
	const debounceTimeoutTbu = useRef(null);
	const debounceTimeoutTemperatura = useRef(null);

	useEffect(() => {
		
		(async () => {
			try {
				if(Condensacao) {
					const res = await apiUltimaLeituraCondensacao.fetchApi(Condensacao.id);
					const temp = res.data?.temperaturaCondensacao || 30;
					setTemperatura(temp);

					const resTbu = await apiTbu.ultimaLeitura();
					const tempTbu = resTbu.data?.tbuCalculado || 30;
					setTbu(tempTbu);

					setPressaoReferenciaRegime((current) => {
						const pressao = temperaturaParaPressao(res.data.temperaturaCondensacao);
						const index = current.findIndex((regime) => regime.id === Condensacao.id);
						if (index === -1) {
							return [...current, { id: Condensacao.id, pressaoReferencia: pressao }];
						}
						const aux = [...current];
						aux[index] = { ...aux[index], pressaoReferencia: pressao };
						return aux;
					});
				}
			} catch (error) {
				setTemperatura(30);
				setTbu(30);
			}
		})()
	},[Condensacao])


	const handleTbu = (value) => {
		if (debounceTimeoutTbu.current) {
			clearTimeout(debounceTimeoutTbu.current);
		}
		debounceTimeoutTbu.current = setTimeout(() => {
			setTbu(current => {
				return parseFloat(value.toString().replace(',', '.'));
			});
		}, delayTime);
	};

	const handleTemperatura = useCallback((value, regimeId) => {
		if (debounceTimeoutTemperatura.current) {
			clearTimeout(debounceTimeoutTemperatura.current);
		}
		debounceTimeoutTemperatura.current = setTimeout(() => {
			setTemperatura(current => {
				return parseFloat(value.toString().replace(',', '.'));
			});
			setPressaoReferenciaRegime((current) => {
				const temp = parseFloat(value.toString().replace(',', '.'));
				const pressao = temperaturaParaPressao(temp);
				const index = current.findIndex((regime) => regime.id === regimeId);
				if (index === -1) {
					return [...current, { id: regimeId, pressaoReferencia: pressao }];
				}
				const aux = [...current];
				aux[index] = { ...aux[index], pressaoReferencia: pressao };
				return aux;
			});
		}, delayTime);
	}, [setPressaoReferenciaRegime]);

	return (
		<>
			{
				temperatura && tbu && (

					<CardLayout>
						<Accordion
							type="single"
							defaultValue="item-1"
							collapsible="true"
						>
							<AccordionItem value="item-1">
								<div className="font-semibold">
									<AccordionTrigger>
										<div className="w-full flex items-center justify-center text-sm lg:text-2xl">
											<p className="text-accent drop-shadow-1xl uppercase">
												{Condensacao?.nome}
											</p>
										</div>
									</AccordionTrigger>
								</div>
								<AccordionContent>
									<div className="flex flex-col lg:flex-row gap-2 px-4">
										<div className="w-full lg:w-1/4 2xl:w-1/3 flex flex-col justify-center">
											<CondensacaoData
												capacidadesRegimes={
													capacidadesRegimes
												}
												pressao={
													temperaturaParaPressao(temperatura)
												}
												condensacao={
													Condensacao
												}
												tbu={
													tbu
												}
												temperatura={
													temperatura
												}
												handleTbu={
													handleTbu
												}
												handleTemperatura={
													handleTemperatura
												}
											/>
										</div>
										<div className="w-full lg:w-3/4 2xl:w-2/3 flex flex-col ">
										
											<TableCondensador
												condensacaoId={
													Condensacao.id
												}
												bombas={
													bombas
												}
												ventiladores={
													ventiladores
												}
												tbu={
													tbu
												}
												temperatura={
													temperatura
												}
												setCapacidadesRegimes={
													setCapacidadesRegimes
												}
											/>
										</div>
									</div>
								</AccordionContent>
							</AccordionItem>
						</Accordion>
					</CardLayout>
				)
			}
		</>
	);
};

export default Condensacao;